import { CEEntityPermissionBase } from './ce-entity-permission-base'


export class CEEntityPermission extends CEEntityPermissionBase {

}